import React from "react";

export default function CustomForm({
    children,
    header,
    formClass,
    extraClassName,
    title,
    col,
    titleCol
}) {
    return (
        <form
            className={`${formClass} ${formClass} grid m-0 p-0 justify-content-between align-items-center overflow-hidden w-full `}
        >
            {title ? (
                <div
                    className={`col-${titleCol || "10"} mb-2 font-bold text-lg karla color-sycamore ${extraClassName}`}
                >
                    {title}
                </div>
            ) : null}
            {header ? (
                <div className={`col-${col || "2"} title my-auto`}>{header}</div>
            ) : null}
            {children}
        </form>
    );
}